import { useContext } from "react";
import CdnConfigContext from "./CdnConfigContext.js";
const useCdnConfigContext = () => {
  const context = useContext(CdnConfigContext);
  if (!context) {
    console.log("useCdnConfigContext must be used within a AssetsConfigContextProvider");
    throw new Error("useCdnConfigContext must be used within a AssetsConfigContextProvider");
  }
  return context;
};
export {
  useCdnConfigContext as default
};
//# sourceMappingURL=useCdnConfigContext.js.map
